// extracted by mini-css-extract-plugin
module.exports = {"playBoardBox":"box_playBoardBox__1kFCO","crossLine":"box_crossLine__1Siy0"};